import { memo } from 'react'
import { IPopoverProps, Popover } from '@cargomart/ui'
import { FloatingOverlay, FloatingPortal } from '@floating-ui/react'
import cn from 'classnames'
import { Modal } from 'components/Modal'
import { useIsMobile } from 'hooks/media'

import s from './Dropdown.module.css'

export interface IDropdownProps extends IPopoverProps {
  id?: string
  isCloseOnMobileOutsideClick?: boolean
  isFullscreenInMobile?: boolean
  menuClassName?: string
}

export const Dropdown = memo(function Dropdown({
  id,
  children,
  triggerEl,
  menuClassName,
  isFullscreenInMobile,
  isCloseOnMobileOutsideClick,
  isCloseOnFocusOut,
  ...rest
}: IDropdownProps) {
  const isMobile = useIsMobile()

  return (
    <Popover
      isCloseOnFocusOut={isMobile ? false : isCloseOnFocusOut}
      shiftOptions={{ mainAxis: false }}
      triggerEl={triggerEl}
      {...rest}
    >
      {(props) =>
        isMobile && isFullscreenInMobile ? (
          <FloatingPortal>
            <FloatingOverlay lockScroll className="z-modal">
              <Modal isMobile id={id} isCloseOnOutsideClick={isCloseOnMobileOutsideClick} onClose={props.onClose}>
                {typeof children === 'function' ? children(props) : <children.type {...children.props} {...props} />}
              </Modal>
            </FloatingOverlay>
          </FloatingPortal>
        ) : (
          <div className={cn(s.content, 'popoverSurface max-w-[320px]', menuClassName)} id={id}>
            {typeof children === 'function' ? children(props) : <children.type {...children.props} {...props} />}
          </div>
        )
      }
    </Popover>
  )
})
